<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Dashboard', icon: 'equalizer', path: `/showroom/${exhibitionId}/dashboard` }"
        />
        <!-- <sidebar-item :link="{ name: 'Company Info', icon: 'info', path: `/showroom/${exhibitionId}/edit/company` }" /> -->
        <!-- <sidebar-item :link="{ name: 'Library', icon: 'library_books', path: `/showroom/${exhibitionId}/edit/library` }" /> -->
        <sidebar-item :link="{ name: 'Lookbook', icon: 'view_in_ar', path: `/showroom/${exhibitionId}/edit/product` }" />
        <!-- <sidebar-item :link="{ name: 'Account', icon: 'account_circle', path: `/showroom/${exhibitionId}/account`}" /> -->
        <sidebar-item :link="{ name: 'Embed', icon: 'link', path: `/showroom/${exhibitionId}/embed`}" />
      </template>
    </side-bar>

    <div class="main-panel">

      <div :class="{ content: !$route.meta.hideContent }">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view />
        </zoom-center-transition>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

// import TopNavbar from "./TopNavbar.vue";
// import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import FixedPlugin from "../../FixedPlugin.vue";
// import UserMenu from "./Extra/UserMenu.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    // TopNavbar,
    // ContentFooter,
    // FixedPlugin,
    MobileMenu,
    // UserMenu,
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
      exhibitionId: null
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  computed: {
    ...mapGetters([
        "getToken",
        "getExhibitionId"
    ])
  },
  mounted() {
    const token = this.getToken;
    if(!token) {
        this.$router.push("/login")

        return;
    }

    this.exhibitionId = this.getExhibitionId;

    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.md-card-header {
  background-color: white !important;
}
.md-button-content {
  color: white;
}
.sidebar[data-color=green] li.active > a:not([data-toggle=collapse]), .off-canvas-sidebar[data-color=green] li.active > a:not([data-toggle=collapse]) {
  background-color: #2ea178 !important;
}
.sidebar .nav p, .off-canvas-sidebar .nav p {
  font-weight: 500 !important;
}
</style>
